import { render, staticRenderFns } from "./SeasonTeamMates.vue?vue&type=template&id=c560576c"
import script from "./SeasonTeamMates.vue?vue&type=script&lang=js"
export * from "./SeasonTeamMates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports